// directives/clickOutside.js
const clickOutside = {
  beforeMount(el, binding) {
    // Define a function to handle clicks outside the element
    const handleClickOutside = (event) => {
      if (!el.contains(event.target) && el !== event.target) {
        // Call the provided function when a click outside the element is detected
        binding.value();
      }
    };

    // Attach the event listener when the directive is mounted
    document.addEventListener("click", handleClickOutside);

    // Store the function on the element's data to be able to remove it later
    el.clickOutsideEvent = handleClickOutside;
  },
  beforeUnmount(el) {
    // Remove the event listener when the directive is unmounted
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

export default clickOutside;
